import { Pipe, PipeTransform } from '@angular/core';
import { PersonTypeEnum } from '@zaoblako/shared/modules/client/enums/person.type.enum';
import { PersonTypeEnumHelperClass } from '@zaoblako/shared/modules/client/classes/person.type.enum.helper.class';

@Pipe({
  standalone: true,
  name: 'personTypeName'
})
export class PersonTypeNamePipe implements PipeTransform {
  public transform(value: PersonTypeEnum): string {
    return PersonTypeEnumHelperClass.getInstance().getDisplayName(value)
  }
}
